import { SeriesOptions } from "highcharts";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { DivisorLabels, Format } from "../../common/utils/format";

export class RevenuesPerOERegionAndYearOutput {
  public constructor(
    public data: any,
    public xLabels: string[],
    public symbol: string
  ) {}
}

// tslint:disable-next-line: cognitive-complexity
export function mapData(
  data: IGenericAggregateResponse
): RevenuesPerOERegionAndYearOutput {
  if (data.aggregates && data.aggregates.length === 0) {
    return new RevenuesPerOERegionAndYearOutput([], [], "K");
  }
  const dimensions = new NbiDimensions();
  const filterDate = data.request ? data.request.date : "";
  const barXArray = [];
  const barData = [];
  let kpiData = [];
  let kpiData1 = [];
  let kpiData2 = [];

  let symbolText: DivisorLabels = "K";
  const million = 1000000;
  const billion = 1000000000;

  for (const item of data.aggregates ? data.aggregates : []) {
    if (item.dimensionAttributeValues[dimensions.OE_RES_REG_CODE] != null) {
      const curYtd = isNaN(item.indicatorKpiValues.nbi_ytd)
        ? 0
        : item.indicatorKpiValues.nbi_ytd;
      const curYtd1 = isNaN(item.indicatorKpiValues.nbi_ytd_1)
        ? 0
        : item.indicatorKpiValues.nbi_ytd_1;
      const curYtd2 = isNaN(item.indicatorKpiValues.nbi_ytd_2)
        ? 0
        : item.indicatorKpiValues.nbi_ytd_2;

      if (
        symbolText === "K" &&
        (curYtd > million || curYtd1 > million || curYtd2 > million)
      ) {
        symbolText = "M";
      }

      if (
        symbolText === "M" &&
        (curYtd > billion || curYtd1 > billion || curYtd2 > billion)
      ) {
        symbolText = "B";
      }

      if (curYtd !== 0 || curYtd1 !== 0 || curYtd2 !== 0) {
        barXArray.push(
          item.dimensionAttributeValues[dimensions.OE_RES_REG_CODE]
        );
        kpiData.push(curYtd);
        kpiData1.push(curYtd1);
        kpiData2.push(curYtd2);
      }
    }
  }
  kpiData = kpiData.map(elem =>
    Format.FormatNumberByLabel(elem, symbolText, 1)
  );
  kpiData1 = kpiData1.map(elem =>
    Format.FormatNumberByLabel(elem, symbolText, 1)
  );
  kpiData2 = kpiData2.map(elem =>
    Format.FormatNumberByLabel(elem, symbolText, 1)
  );

  if (barXArray.indexOf("Other") > -1) {
    const oldIndex = barXArray.indexOf("Other");
    const newIndex = barXArray.length - 1;
    barXArray.splice(newIndex, 0, barXArray.splice(oldIndex, 1)[0]);
    kpiData.splice(newIndex, 0, kpiData.splice(oldIndex, 1)[0]);
    kpiData1.splice(newIndex, 0, kpiData1.splice(oldIndex, 1)[0]);
    kpiData2.splice(newIndex, 0, kpiData2.splice(oldIndex, 1)[0]);
  }
  const currentYear = filterDate.slice(0, 4);
  barData[0] = {
    data: kpiData2,
    name: (Number(currentYear) - 2).toString(),
  };
  barData[1] = {
    data: kpiData1,
    name: (Number(currentYear) - 1).toString(),
  };
  barData[2] = { name: currentYear, data: kpiData };
  return new RevenuesPerOERegionAndYearOutput(barData, barXArray, symbolText);
}
